/**
 * banner api
 */
import { API_PREFIX } from '@shared/config';
import { httpClient, searchToJson } from '@shared/utils';
import { type ApiResult } from '../apis';

const staffParams = {
  staffId: searchToJson().staffId || import.meta.env.VITE_MOCK_LOGIN_STAFF_ID,
};
// 活动列表类别
export const getBannerCategoryList = async <U, T>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/applet/banner/category/list.do`, { params: { ...params, ...staffParams } });

// 活动列表
export const getBannerList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/banner/train/filter_list.do`, params);
